import React from 'react';
import MachinistFooter from './MachinistFooter';
import { cn } from '@/utils/utils';
import { MachinistHeader } from '@/modules/maquinista/MachinistHeader';
import { SuspenseLoader } from './SuspenseLoader';
import { OfflineIndicator } from '@/components/OfflineIndicator';
import { FailedOfflineMutations } from '@/components/FailedOfflineMutations';

const MachinistLayout: React.FC<{
  children?: React.ReactNode;
}> = ({ children }) => {
  return (
    <>
      <div>
        <MachinistHeader />
        <OfflineIndicator />
        <FailedOfflineMutations />
      </div>
      <main
        className={cn(
          'flex w-full h-full p-0 m-0 flex-col overflow-x-hidden! overflow-y-auto! bg-sidebar'
        )}
      >
        <React.Suspense fallback={<SuspenseLoader />}>
          {children}
        </React.Suspense>
      </main>
      <MachinistFooter />
    </>
  );
};

export default MachinistLayout;
